import { array, boolean, literal, nativeEnum, number, object, preprocess, z } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Earning_Mechanism_Product_Counting_Attribute } from '@occc/graphql';
import { ProductGroupsSchema } from '@occc/validation';

import { ChallengeAwardSchema } from './award.schema';
import { BaseChallengeSchema } from './base-challenge.schema';

import { ChallengeType } from '../constants';

export const ProductChallengeEarningMechanismSchema = object({
  products: array(
    object({
      purchaseThreshold: number({ required_error: IS_REQUIRED }).positive(IS_POSITIVE),
      eligibleProductGroups: ProductGroupsSchema,
      countProductsBy: nativeEnum(Earning_Mechanism_Product_Counting_Attribute),
    }),
  ).optional(),
  earningMechanism: z.enum(['varietyPurchase', 'varietyPurchaseOverTime']),
  stayVisibleWhileInProgress: object({ isEnabled: boolean() }).optional(),
});

export const ProductChallengeFormSchema = BaseChallengeSchema.extend({
  challengeType: literal(ChallengeType.ProductChallenge),
  productChallenge: preprocess((val) => val ?? {}, ProductChallengeEarningMechanismSchema),
  award: preprocess((val) => val ?? {}, ChallengeAwardSchema),
});
